const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleDateString('pl-PL');
};

export default formatDate;
